export default __webpack_public_path__ + "static/media/miut_panorama.b5459c44.png";